import React, { useContext, useEffect, useState } from "react";
import {
   
  IonButton,
  IonFab,
  IonFabButton,
  IonFabList,
  IonIcon,
  IonItem,
  
  IonToolbar,
} from "@ionic/react";

import { DataContext } from "../context/DataContext";
import { cogOutline, peopleCircleOutline, person } from "ionicons/icons";

const Toolbar: React.FC = () => {
    const { 
            appLoggedIn
          } = useContext(DataContext);

  return (
    <IonToolbar >
          <IonItem slot="start" lines="none" routerLink="/">
            <img style={{ height: "50px" }} alt="SAINT" src="assets/schulcatering_logo.svg"/>
          </IonItem>
          <IonItem lines="none">Kunterbunte Küche</IonItem>
          <IonItem slot="end" lines="none">
              
            </IonItem>
            
        </IonToolbar>
  );
};

export default Toolbar;
